import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Content } from '../../infrastructure/content';
import PropTypes from '../../types';

const SetUpInProgressPage = () => (
  <Content>
    {({ setUpInProgressHeader, setUpInProgressLead, setUpInProgressPara, headerTitle = '' }) => (
      <StandardBody>
        <PageHeading>{setUpInProgressHeader}</PageHeading>
        <p>{setUpInProgressLead}</p>
        <p>{setUpInProgressPara}</p>
      </StandardBody>
    )}
  </Content>
);

SetUpInProgressPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default SetUpInProgressPage;
